import Resource from './common/resource';

class Links extends Resource {
  path = 'org';
}

export default Links;
